<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import '@/utils/mixins/router-mixin.js';
import '@/utils/mixins/global-mixin.js';

export default {
  name: 'App',
  data() {
    return {
      // Used to load values from localStorage into the VueX Store
      // Key = localStorage key
      // Value = VueX Mutation to commit
      localStorageSetup: {
        'managing-product': 'setCurrentProductSKU',
      },
    };
  },
  methods: {
    preventNav(event) {
      if (this.$store.getters.uploading) {
        event.preventDefault();
        event.returnValue = '';
      }
    },
    checkLocalStorage() {
      const version = process.env.VUE_APP_LOCAL_STORAGE_VERSION;
      const keys = Object.keys(localStorage);
      if (version !== localStorage.getItem('local_storage_version')) {
        keys.forEach(key => {
          if (!key.includes('CognitoIdentity')) {
            localStorage.removeItem(key);
          }
        });
        localStorage.setItem('local_storage_version', version);
      }
    },
    setupStoreFromLocalStorage() {
      Object.keys(this.localStorageSetup).forEach(key => {
        const lsData = localStorage.getItem(key);
        if (lsData) {
          this.$store.commit(this.localStorageSetup[key], lsData);
        }
      });
    },
  },
  created() {
    window.addEventListener('beforeunload', this.preventNav);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('beforeunload', this.preventNav);
    });
    this.checkLocalStorage();
    this.setupStoreFromLocalStorage();
  },
};
</script>

<style lang="less">
body {
  overflow: hidden;
}
#app {
  height: 100%;
}
</style>
